import {
  currentPushSubscription,
  ensurePushSubscription,
  isIosWithoutHomeScreen,
  pushSupported,
  subscriptionPayload,
} from '@/utils/push'

export const NOTIFICATION_EVENTS = [
  { value: 'DELAY', title: 'Verspätung' },
  { value: 'CANCELLATION', title: 'Ausfall' },
  { value: 'PLATFORM', title: 'Gleiswechsel' },
  { value: 'DEPARTURE_ARRIVAL', title: 'Abfahrt & Ankunft (Prognose)' },
  { value: 'ROUTE', title: 'Umleitung & Zusatzhalte' },
]

// Push subscriptions for one trip. API calls live here rather than in a store
// module: plugins/axios.js imports the store, so a store module importing the
// API would be an import cycle.
export default {
  data: () => ({
    // Notification.permission is not reactive; mirrored here and updated after
    // every request for it.
    notificationPermission: typeof Notification !== 'undefined' ? Notification.permission : 'denied',
  }),

  computed: {
    pushSupported: function() {
      return pushSupported()
    },

    pushNeedsHomeScreen: function() {
      return !pushSupported() && isIosWithoutHomeScreen()
    },

    notificationSubscriptions: function() {
      return this.$store.state.notifications.subscriptions
    },
  },

  methods: {
    notificationFor: function(tripId) {
      return this.notificationSubscriptions.find(subscription => subscription.tripId === tripId) || null
    },

    subscribeNotifications: async function(options) {
      if (!pushSupported()) {
        throw new Error('Dieser Browser unterstützt keine Push-Benachrichtigungen.')
      }

      // Asked here, on the user's click — never on page load.
      var permission = await Notification.requestPermission()
      this.notificationPermission = permission
      if (permission !== 'granted') {
        throw new Error('Benachrichtigungen sind für Bahnomat blockiert. Sie lassen sich in den Website-Einstellungen des Browsers erlauben.')
      }

      try {
        var key = await this.$api.get('/notifications/vapid-key')
        var subscription = await ensurePushSubscription(key.data.publicKey)
        var response = await this.$api.put('/notifications/subscriptions', {
          ...subscriptionPayload(subscription),
          tripId: options.tripId,
          fromEva: options.fromEva,
          toEva: options.toEva,
          events: options.events,
          delayThresholdMinutes: options.delayThresholdMinutes,
        })
        this.$store.commit('upsertNotificationSubscription', response.data)
        return response.data
      } catch (err) {
        throw new Error(this.notificationErrorMessage(err))
      }
    },

    unsubscribeNotifications: async function(tripId) {
      var subscription = await currentPushSubscription()
      if (subscription) {
        try {
          await this.$api.post('/notifications/subscriptions/remove', {
            endpoint: subscriptionPayload(subscription).endpoint,
            tripId: tripId,
          })
        } catch (err) {
          throw new Error(this.notificationErrorMessage(err))
        }
      }
      this.$store.commit('removeNotificationSubscription', tripId)
    },

    // Re-reads this device's subscriptions. Silent on failure: the list is a
    // convenience, and an unreachable backend must not break the page.
    syncNotificationSubscriptions: async function() {
      try {
        var subscription = await currentPushSubscription()
        if (!subscription) {
          this.$store.commit('setNotificationSubscriptions', [])
          return
        }
        var response = await this.$api.post('/notifications/subscriptions/lookup', {
          endpoint: subscriptionPayload(subscription).endpoint,
        })
        this.$store.commit('setNotificationSubscriptions', response.data || [])
      } catch (err) {
        this.$log.warn(`Could not sync notification subscriptions: ${err && err.message}`)
      }
    },

    notificationErrorMessage: function(err) {
      var response = err && err.response
      if (response && response.data && response.data.message) {
        return response.data.message
      }
      if (response && response.status === 503) {
        return 'Benachrichtigungen sind gerade nicht verfügbar.'
      }
      if (err && err.name === 'NotAllowedError') {
        return 'Der Browser hat das Abonnieren abgelehnt.'
      }
      return 'Das hat nicht geklappt. Bitte später noch einmal versuchen.'
    },
  },
}
